export default __webpack_public_path__ + "static/media/cl-logo.a4a523f4.svg";